import { render, staticRenderFns } from "./simple-dropdown.vue?vue&type=template&id=a82dbf6c&"
import script from "./simple-dropdown.vue?vue&type=script&lang=ts&"
export * from "./simple-dropdown.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports